const gray = {
  97: '#f7f7f7',
  93: '#ededed',
  85: '#d9d9d9',
  75: '#bfbfbf',
  65: '#a6a6a6',
  55: '#8c8c8c',
  45: '#737373',
  35: '#595959',
  25: '#3f3f3f',
};

export default gray;
